/*
 * @Description: 优惠券列表
 * @Author: 段生华
 * @Date: 2019-05-07 17:20:24
 * @LastEditTime: 2019-06-28 10:04:15
 * @LastEditors: Please set LastEditors
 */

import React from 'react';
import {Divider, message, Popconfirm} from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import {postFrom, config, post} from '../../axios';
import {formatTime, moneyAddComma} from '../../utils/index'
import {dicDiscountCouponStatus, dicPayType} from '../../axios/dictionaries';
 import ListAdd from './components/ListAdd';

export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: { //搜索参数
                keyword: '',          //关键字
                pageSize: 10,
                payType:'',
                mustPayDate:''
            },
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showAddModal: false, //显示新增/编辑
        }
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            showAddModal,
        } = this.state;

        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper">
                    <div className="search-btn-list">
                        <AuthButton authkey="j-3-1" type="primary" icon="plus" onClick={() => { this.setState({ showAddModal: true }); this.ListAddRef.initPack(); }}>优惠券新增</AuthButton>
                    </div>
                    <SuperForm
                        data={searchData()}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />
                </div>
                <TableDOM
                    columns={columns({ handleEdit: this.handleEdit,handleEditStatus:this.handleEditStatus })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    current={current}
                    onChange={this.handleSearch}
                />
                <ListAdd
                    onRef={ref => this.ListAddRef = ref}
                    visible={showAddModal}
                    handleCancel={() => { this.setState({ showAddModal: false }) }}
                    handleGetList={this.handleSearch}
                />
            </PageWrap>
        )
    }

    componentDidMount() {
        this.handleSearch();
    }

    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, current } = this.state;
        let data = {};

        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        postFrom({ url: config.API_coupon_findPageList, data }).then(res => {
            this.setState({ current: res.current, tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }

    handleEdit = (id) => { //编辑
        this.setState({ showAddModal: true });
        this.ListAddRef.loadPack({ id });
        this.ListAddRef.initPack();
    }
    handleEditStatus=(id,status) =>{


        post({ url: config.API_coupon_updateDiscountCouponStatus, data: { status, id } }).then(res => {
            message.success('操作成功');
            this.handleSearch();
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        })
    }
}

const searchData = () => [
    {
        tagName: 'MonthPicker',
        formConfig: { name: 'mustPayDate' },
        attribute: { placeholder: '请选择生效月份',type:'month',format:"YYYY-MM", style: { width: "172.7px" } },
    },
    {
        tagName: 'Select',
        formConfig: { name: 'payType' },
        attribute: { placeholder: '请选择支付类型', style: { width: '160px' } },
        optionData: [{ title: '全部', value: '' }].concat(dicPayType.filter(item => (item.value ===3)||(item.value ===7))),
        notResult: '',
    },
    {
        tagName: 'Select',
        formConfig: { name: 'status' },
        attribute: { placeholder: '请选择优惠券状态', style: { width: '160px' } },
        optionData: [{ title: '全部', value: '' }].concat(dicDiscountCouponStatus),
        notResult: '',
    },
    {
        tagName: 'InputTip',
        formConfig: { name: 'keyword' },
        attribute: { placeholder: '输入关键字', style: { width: '160px' } },
        title: '在优惠券名称及账单费项内模糊查询'
    },

];

const columns = ({ handleEdit , handleEditStatus}) => [
    {
        title: '优惠券名称',
        dataIndex: 'couponName',
    },
    {
        title: '账单费项',
        dataIndex: 'feeName',
    },
    {
        title: '支付方式',
        dataIndex: 'payType',
        render(text){
            if(text){
                let now = dicPayType.find(item => item.value === text);
                if (now)
                    return <span>{now.title}</span>;
            }else{
                return "";
            }


        }
    },
    {
        title: '生效月份',
        dataIndex: 'mustPayDate',
    },
    {
        title: '减免金额',
        dataIndex: 'creditAmount',
        render(text){
            return moneyAddComma(text);
        }
    },
    {
        title: '最低触发金额',
        dataIndex: 'minFeeNameAmount',
        render(text){
            return moneyAddComma(text);
        }
    },
    {
        title: '更新时间',
        dataIndex: 'updateTime',
        render(text) {
            if (!text) return '-'
            return formatTime(text)
        }
    },
    {
        title: '优惠券状态',
        dataIndex: 'status',
        render(text, record, index) {
            let now = dicDiscountCouponStatus.find(item => item.value === text);
            if (now)
                return <span style={{ color: now.color }}>{now.title}</span>;
            return null
        }
    },

    {
        title: '操作',
        dataIndex: 'action',
        width: 100,
        render(text, record, index) {
            return (
                <React.Fragment>
                <AuthButton authkey="j-3-2">
                    <span className="showClickDetail" onClick={() => { handleEdit(record.id) }}>编辑</span>
                    <Divider type="vertical" />
                </AuthButton>
                <AuthButton authkey="j-3-3">
                    <Popconfirm
                        placement="topRight"
                        title={record.status===2?'此优惠券确认启用吗?':'此优惠券确认禁用吗?如果禁用则不会在发放优惠券!'}
                        onConfirm={() => {

                            handleEditStatus(record.id, record.status===2?1:2);
                        }}
                        okText={record.status===2?'启用':'禁用'}
                        cancelText="取消"
                    >
                    <span className="showClickDetail" >{record.status===2?'启用':'禁用'}</span>
                    </Popconfirm>
                </AuthButton>

                </React.Fragment>
                    )

        }
    },
];



// WEBPACK FOOTER //
// ./src/page/Coupons/List.js